import { ListRequestUnlockReducer } from "../reducer/CompanyListRequestUnlockReducer";

export const reducer = ListRequestUnlockReducer;